import React, { Component } from 'react'
import modalStyle from '../../style/modal.module.css'

class Modal extends Component {

  componentWillUnmount(){
    document.body.style.overflow = "visible";
  }
    render() {
        if (this.props.isOpen === false){
          document.body.style.overflow = "visible";
          return null
        }
        else{
          document.body.style.overflow = "hidden";
        }
  
        
        return (
          <div>
            <div className={modalStyle.modal__backdrop}>
              <div className={modalStyle.modal__container}>
              {this.props.children}
              </div>
              
            </div>
          </div>
        )
      }
  
      close(e) {
        e.preventDefault()
  
        if (this.props.onClose) {
          this.props.onClose()
        }
      }
}
export default  Modal;
